var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainNavbar'),_c('b-container',[_c('b-card',{staticClass:"my-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',[_c('FormAlert')],1)],1)],1)],1)],1),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }